import { QcConversationDesignSchema } from "../group/QcConversationDesign";
import { QcConversationDetailForUserSchema } from "../group/QcConversationDetailForUser";
import { MessageSchema } from "./Message";
import { QcBizConversationInfoSchema } from "./QcBizConversationInfo";
import { CallCenterStatusSchema } from "./CallCenterStatus";
// import { ConvMemberSchema } from "./ConvMember";
import { QcUserSchema } from "@/modules/staff/objects/conversation/QcUser";
import { z } from "zod";
import { QcConversationMemberSchema } from "../group/QcConversationMember";

export type QcConversation = z.infer<typeof QcConversationSchema>;
export const QcConversationSchema = z.object({
  id: z.string(),
  id_account: z.number(),
  name: z.string(),
  conversation_type: z.string(),
  description: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
  icon: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
  qr: z
    .string()
    .optional()
    .transform((value) => value ?? ""),
  invite_approval_type: z.string(),
  notification_range: z.string(),
  last_talk_at: z.string(),
  created_at: z.string(),
  updated_at: z.string(),
  importance: z.number(),
  has_unread: z
    .boolean()
    .optional()
    .transform((value) => value ?? false),
  has_guest_unread: z.boolean(),
  members: z.object({
    items: z.array(QcConversationMemberSchema),
    // items: z.array(GroupMemberSchema),
    nextPage: z.number(),
  }),
  messages: z.object({
    items: z.array(MessageSchema),
    nextToken: z
      .string()
      .nullable()
      .transform((value) => value ?? ""),
  }),
  biz_conv_info: QcBizConversationInfoSchema,
  design: QcConversationDesignSchema,
  conversation_detail: QcConversationDetailForUserSchema.optional(),
  owner_user: QcUserSchema.optional(),
  cc_status: CallCenterStatusSchema,
  memberLimitInfo: z.object({ current: z.number(), limit: z.number() }).nullable().optional(),
  is_anonymous_join: z.boolean().optional(),
});
